// Angular
import { Injectable } from '@angular/core';

/**
 * Business logic for the withdraw wire-transfer component.
 * The view is static (contact-support instructions), so there is no
 * logic to run yet; this service is the home for any future behavior.
 */
@Injectable()
export class WithdrawWireTransferService {}
